import { forwardRef } from 'react';
import { RootComponent } from '../../../../services/root-component';
import { BadgeProps } from '../../types';
import css from './style.module.css';

export const Layout = forwardRef<HTMLDivElement, BadgeProps>(
  function Component(props, forwardedRef) {
    return (
      <RootComponent
        {...props}
        Component="div"
        baseClassName={css.root}
        ref={forwardedRef}
      />
    );
  }
);
